import { createPageDataFeature } from '../../page-data/create-page-data-feature';
import { CryptoToken } from 'src/app/shared/entities/crypto-token';
import { createDeleteItemFeature } from '../../delete-item/delete-item-feature';

export const {
  feature: cryptotokenDataFeature,
  selectors: CryptotokenDataSelectors,
  actions: CryptotokenDataActions,
  pipes: CryptotokenDataPipes,
  createEffects: createCryptotokenDataEffects,
} = createPageDataFeature<'Cryptotoken Data', void, CryptoToken[]>(
  'Cryptotoken Data',
);

export const {
  feature: cryptotokenDeleteFeature,
  actions: CryptotokenDeleteActions,
  createEffects: createCryptotokenDeleteEffects,
} = createDeleteItemFeature<'Cryptotoken Delete', CryptoToken>(
  'Cryptotoken Delete',
);

export const CryptotokenDeleteSelectors = {
  cryptotokenBeingDeleted: cryptotokenDeleteFeature.selectItemBeingDeleted,
  isDeleting: cryptotokenDeleteFeature.selectDeleting,
};
